import * as types from '../action.types';

export const initialState = {
  isUploadingFile: false,
  isProcessingRules: false,
  isFetchingSessions: false,
  isFetchingSession: false,
  isSavingSession: false,
  isFetchingSessionFiles: false,
  isFetchingMapping: false,
  isCreatingVirtualFile: false,
  isSaved: true,
  searchTerm: '',
  currentSessionId: '',
  currentFileId: '',
};

const StatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_FILE_REQUEST:
      return { ...state, isUploadingFile: true };

    case types.ADD_FILE_ERROR:
      return { ...state, isUploadingFile: false };

    case types.ADD_FILE_SUCCESS:
      return {
        ...state,
        isUploadingFile: false,
        currentSessionId: action.payload.sessionId,
        currentFileId: action.payload.id,
      };

    case types.FETCH_SESSION_SUCCESS:
      return {
        ...state,
        isFetchingSession: false,
        currentSessionId: action.payload.sessionId,
        currentFileId: action.payload.id,
      };

    case types.APPLY_RULE_START:
      return { ...state, isProcessingRules: true };

    case types.APPLY_RULE_DONE:
      return { ...state, isProcessingRules: false };

    case types.FETCH_SESSIONS_REQUEST:
      return { ...state, isFetchingSessions: true };

    case types.FETCH_SESSIONS_SUCCESS:
    case types.FETCH_SESSIONS_ERROR:
      return { ...state, isFetchingSessions: false };

    case types.FETCH_SESSION_REQUEST:
    case types.DELETE_SESSION_REQUEST:
    case types.DELETE_SESSION_FILE_REQUEST:
    case types.UPDATE_FILE_ACTIVE_REQUEST:
    case types.UPDATE_SESSION_NAME_REQUEST:
      return { ...state, isFetchingSession: true };

    case types.DELETE_SESSION_SUCCESS:
    case types.DELETE_SESSION_FILE_SUCCESS:
    case types.FETCH_SESSION_ERROR:
    case types.DELETE_SESSION_ERROR:
    case types.DELETE_SESSION_FILE_ERROR:
    case types.UPDATE_FILE_ACTIVE_ERROR:
    case types.UPDATE_FILE_ACTIVE_SUCCESS:
    case types.UPDATE_SESSION_NAME_ERROR:
    case types.UPDATE_SESSION_NAME_SUCCESS:
      return { ...state, isFetchingSession: false };

    case types.FETCH_MAPPING_REQUEST:
      return { ...state, isFetchingMapping: true };

    case types.FETCH_MAPPING_SUCCESS:
      return { ...state, isFetchingMapping: false, isSaved: false};
    case types.FETCH_MAPPING_ERROR:
      return { ...state, isFetchingMapping: false };

    case types.FETCH_SESSION_FILES_REQUEST:
      return { ...state, isFetchingSessionFiles: true };

    case types.FETCH_SESSION_FILES_SUCCESS:
    case types.FETCH_SESSION_FILES_ERROR:
      return { ...state, isFetchingSessionFiles: false };

    case types.SAVE_SESSION_REQUEST:
      return { ...state, isSavingSession: true };

    case types.SAVE_SESSION_ERROR:
      return { ...state, isSavingSession: false };

    case types.SAVE_SESSION_SUCCESS:
      return { ...state, isSaved: true, isSavingSession: false };

    case types.CREATE_VIRTUAL_FILE_START:
      return {
        ...state,
        isCreatingVirtualFile: true,
        currentSessionId: action.payload.sessionId,
      };

    case types.CREATE_VIRTUAL_FILE_DONE:
      return { ...state, isCreatingVirtualFile: false };

    case types.UPDATE_SEARCH_TERM:
      return { ...state, searchTerm: action.payload };

    case types.CREATE_NEW_RULE:
    case types.UPDATE_RULE_ACTIVE:
    case types.UPDATE_RULE:
    case types.UPDATE_RULE_ORDER:
    case types.UPDATE_METADATA_ORDER:
    case types.UPDATE_FILE_NOTES_EDITOR_CONTENT:
    case types.UPDATE_FILE_RULES_APPLIED:
    case types.UPDATE_FILE_SKIPPED_COLUMNS_HIDDEN:
    case types.SET_METADATA_TYPE:
    case types.SET_METADATA_FORMAT:
    case types.SET_METADATA_FIELD_TYPE:
    case types.CREATE_NEW_METADATA:
    case types.DELETE_MAPPING_ITEM:
    case types.DELETE_METADATA_ITEM:
    case types.DELETE_RULE:
    case types.CLEAR_MAPPING:
    case types.SET_TARGET_VALUE:
      return { ...state, isSaved: false };

    default:
      return state;
  }
};

export default StatusReducer;
